var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgOvalBackground = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1440 106",
  style: {
    enableBackground: "new 0 0 1440 106"
  },
  xmlSpace: "preserve"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0,0v106h0.1C37.3,90,84,75.3,138.8,62.4C215.1,44.3,305.7,30,405.4,20.1c99.7-9.9,206.6-15,314.5-15.2 c108-0.1,214.9,4.7,314.6,14.3c99.7,9.5,190.3,23.7,266.7,41.5c54.9,12.8,101.5,29.4,138.8,45.3V0H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1301.2,60.7c-76.4-17.8-167-32-266.7-41.5C934.8,9.6,827.9,4.8,719.9,4.9C612,5.1,505.1,10.2,405.4,20.1 S215.1,44.3,138.8,62.4C84,75.3,37.3,90,0.1,106h1440C1402.8,90.1,1356.1,73.5,1301.2,60.7z"
})));
export default SvgImgOvalBackground;